import PropTypes from 'prop-types';

import { useCallback, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useSelector } from 'react-redux';

import CopyComponent from 'components/field/CopyComponent';
import FormItem from 'components/form/FormItem';

import useAxiosPrivate from 'hooks/useAxiosPrivate';
import { usePrompt } from 'hooks/usePrompt';

import { SALES_CHANNELS } from 'services/consts';

import AppLogger from 'utils/AppLogger';

import * as S from '../SalesChannel.styled';
import BaseSalesChannelForm from './BaseSalesChannelForm';

export const RetailerCredentialsForm = () => {
	const {
		watch,
		setValue,
		formState: { isSubmitting, isDirty, isSubmitSuccessful, isLoading: isFormLoading }
	} = useFormContext();
	const { salesChannel } = useSelector((state) => state.salesChannel);
	const axios = useAxiosPrivate();
	const isLoading = isSubmitting || isFormLoading;
	usePrompt(isDirty && !isSubmitting && !isSubmitSuccessful);

	const getGenerateCredentialsV1 = useCallback(async () => {
		try {
			const response = await axios.post(SALES_CHANNELS.GENERATE_CREDENTIALS_V1);

			if (response.status === 200) {
				setValue('retailerID', response.data.retailerID);
				setValue('refreshToken', response.data.refreshToken);
			} else {
				AppLogger.error(response);
			}
		} catch (error) {
			AppLogger.error(error);
		}
	}, []);

	useEffect(() => {
		getGenerateCredentialsV1();
	}, []);
	return (
		<S.StoreAccordion header="storeDetails" defaultVisible>
			<BaseSalesChannelForm isLoading={isLoading} whRequired={salesChannel.slug === 'store-hippo'}>
				<FormItem label="retailerID" isLoading={isLoading}>
					<CopyComponent value={watch('retailerID')} />
				</FormItem>
				<FormItem label="refreshToken" isLoading={isLoading}>
					<CopyComponent value={watch('refreshToken')} />
				</FormItem>
			</BaseSalesChannelForm>
		</S.StoreAccordion>
	);
};

RetailerCredentialsForm.propTypes = {
	whRequired: PropTypes.bool
};

export default RetailerCredentialsForm;
